import { dataHooks } from '@wix/data-hooks'

export const wixMobileGetOwnerAppDataHooks = dataHooks<{
  successMesssage: {}
  back: {}
  illustrationImage: {}
  title: {}
  description: {}
  optionButton: {
    optionKey: string
  }
  next: {}
}>('wix-mobile-split')
